<template>
	<div id="public-app" class="public-app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'PublicApp',
}
</script>
